
export const getAPIURL = () => {

    // console.log("Welcome React");
    // console.log(process.env.NODE_ENV);
    var environment = process.env.NODE_ENV
    // console.log("Environment : " + environment);

    // const apiUrl = 'http://localhost/omniwheels/bb-payroll-api/';
    // const apiUrl = 'https://api.payroll-dev.suncolleges.ac.in/';
    const apiUrl = 'https://api.payroll.suncolleges.ac.in/';

    return apiUrl;
}

export const getApiUrlForCampus = () => {

    // const apiUrlForCampus = 'https://api.campus-uat.suncolleges.ac.in/';
    const apiUrlForCampus = 'https://api.campus.suncolleges.ac.in/';

    return apiUrlForCampus;
}

// getLicenseKey
export const getLicenseKey = 5566;